import { useRouteError } from "react-router-dom";
import "./errorPage.css";

/**
 * @description This component will render a 404 page
 * @component ErrorPage
 */
export function ErrorPage() {
  const error: any = useRouteError();
  console.error(error);

  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
    </div>
  );
}
